import { Typography } from "@mui/material";
import { useSearchParams } from "react-router-dom";

import { useTeaching } from "../hooks/useTeaching";
import moment from "moment";
import { FaCheckCircle } from "react-icons/fa";
import classNames from "classnames";
import { lessonType } from "../../../../constants";

export function SyllabusRightColumn() {
	const { summary } = useTeaching();
	const [searchParams, setSearchParams] = useSearchParams();

	if (!summary) {
		return null;
	}

	const firstClass = summary.bookings[0];

	const classId = searchParams.get("class") ?? firstClass.id ?? 0;

	return (
		<>
			<div className="column-title">
				<Typography className="small-title-text bold">Syllabus</Typography>
			</div>
			<div style={{ flex: 1 }}>
				{summary.bookings.map((booking) => {
					let passed = false;

					if (
						booking.lesson.type === lessonType.ONSITE &&
						new Date() > new Date(booking.endTime ?? "")
					) {
						passed = true;
					}
					if (booking.lesson.type === lessonType.ONLINE && booking.passed) {
						passed = true;
					}

					return (
						<div
							className={classNames(
								"lesson-item-container item-separator-small",
								{ selected: classId === booking.id.toString() },
							)}
							onClick={() => {
								setSearchParams((prev) => {
									prev.set("class", booking.id.toString());
									return prev;
								});
							}}
							key={booking.id}>
							<div style={{ flex: 1 }}>
								<Typography className="normal-text bold">
									{booking.lesson.title}
								</Typography>
								{booking.startTime && booking.endTime && (
									<Typography className="small-text">
										{moment(booking.startTime).format("ddd, DD MMM, YYYY")}
									</Typography>
								)}
							</div>
							{passed && (
								<div>
									<FaCheckCircle className="normal-icon check-icon" />
								</div>
							)}
						</div>
					);
				})}
			</div>
		</>
	);
}
